import type { ReactElement } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import TruncatedTextWithTooltip from "app/pages/sales-intelligence/common-components/TruncatedText/TruncatedTextWithTooltip";

const TopCompanyAssociatedListEmptyLink = (): ReactElement => {
    return (
        <Flex
            alignItems="center"
            gap="4px"
            data-automation="top-companies.associated-list-empty"
        >
            <SWReactIcons
                iconColor={colorsPalettes.carbon[200]}
                iconName="sparkles-ai-2"
                size="14px"
            />

            <TruncatedTextWithTooltip
                fontVariant="listItem3"
                color={colorsPalettes.carbon[250]}
            >
                {translate("si.top-companies.associated-list.ai-suggested")}
            </TruncatedTextWithTooltip>
        </Flex>
    );
};

export default TopCompanyAssociatedListEmptyLink;
